import { formatDate } from '@/lib/date-helper';

export function date(date: Date | string, showTime = false) {
  return formatDate(date, showTime);
}
